import { useEffect } from 'react'
import { useToasterStore } from 'react-hot-toast'
import { useNotificationHistoryStore } from '@/stores/notificationHistoryStore'

function normalizeToastMessage(message: unknown): string {
  if (typeof message === 'string') return message
  if (typeof message === 'number' || typeof message === 'boolean') return String(message)
  return 'Notification'
}

/** Read-only dump for Playwright; keep it out of the toast-sync component so store writes cannot loop. */
function ErrorNotificationDump() {
  const items = useNotificationHistoryStore((s) => s.items)
  const errorItems = items.filter((item) => item.type === 'error')
  return (
    <div data-testid="app-error-notifications" hidden aria-hidden="true">
      {errorItems.map((item) => (
        <span key={item.id} data-id={item.id} data-created-at={String(item.createdAt)}>
          {item.message}
        </span>
      ))}
    </div>
  )
}

export default function ToastNotificationBridge() {
  const { toasts } = useToasterStore()
  const addOrUpdate = useNotificationHistoryStore((s) => s.addOrUpdate)

  useEffect(() => {
    toasts.forEach((toastItem) => {
      if (!toastItem.visible) return
      addOrUpdate({
        id: String(toastItem.id),
        message: normalizeToastMessage(toastItem.message),
        type: toastItem.type,
        createdAt: toastItem.createdAt,
      })
    })
  }, [toasts, addOrUpdate])

  return <ErrorNotificationDump />
}
